"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _OperatingSystems = _interopRequireDefault(require("AudienceTargetingUIComponents/constants/OperatingSystems"));

var _DeviceTypes = _interopRequireDefault(require("AudienceTargetingUIComponents/constants/DeviceTypes"));

var _Contacts = _interopRequireDefault(require("AudienceTargetingUIComponents/constants/Contacts"));

var _Filters = require("AudienceTargetingUIComponents/constants/Filters");

var _Operators = require("AudienceTargetingUIComponents/constants/Operators");

var _FilterCountrySelect = _interopRequireDefault(require("./Inputs/FilterCountrySelect"));

var _FilterGenericSelect = _interopRequireDefault(require("./Inputs/FilterGenericSelect"));

var _FilterLanguageSelect = _interopRequireDefault(require("./Inputs/FilterLanguageSelect"));

var _FilterNumberInput = _interopRequireDefault(require("./Inputs/FilterNumberInput"));

var _FilterTextInput = _interopRequireDefault(require("./Inputs/FilterTextInput"));

var _FilterTopicSelect = _interopRequireDefault(require("./Inputs/FilterTopicSelect"));

var _FilterKeyValueInput = _interopRequireDefault(require("./Inputs/FilterKeyValueInput"));

var _FilterMultiSelect = _interopRequireDefault(require("./Inputs/FilterMultiSelect"));

var _FilterListsSelect = _interopRequireDefault(require("./Inputs/FilterListsSelect"));

var FilterInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FilterInput, _Component);

  function FilterInput() {
    (0, _classCallCheck2.default)(this, FilterInput);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterInput).apply(this, arguments));
  }

  (0, _createClass2.default)(FilterInput, [{
    key: "handleValueChange",
    value: function handleValueChange(value) {
      this.props.onChange(value.target.value);
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          type = _this$props.type,
          operator = _this$props.operator,
          labelConfig = _this$props.labelConfig,
          value = _this$props.value,
          size = _this$props.size;
      var normalizedValue;

      if (!_Filters.FILTERS[type]) {
        return null;
      }

      if (operator === _Operators.ALL) {
        return null;
      }

      switch (_Filters.FILTERS[type].type) {
        case _Filters.FILTER_TYPES.COUNTRY:
          return _react.default.createElement(_FilterCountrySelect.default, {
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: value
          });

        case _Filters.FILTER_TYPES.LANGUAGE:
          return _react.default.createElement(_FilterLanguageSelect.default, {
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: value
          });

        case _Filters.FILTER_TYPES.OPERATING_SYSTEM:
          return _react.default.createElement(_FilterGenericSelect.default, {
            labelConfig: labelConfig,
            multi: true,
            options: _OperatingSystems.default,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: value,
            type: "operatingSystem",
            size: "long"
          });

        case _Filters.FILTER_TYPES.DEVICE_TYPE:
          return _react.default.createElement(_FilterGenericSelect.default, {
            labelConfig: labelConfig,
            multi: true,
            options: _DeviceTypes.default,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: value,
            type: "deviceType",
            size: "long"
          });

        case _Filters.FILTER_TYPES.NUMBER:
          normalizedValue = isNaN(value) ? null : value;
          return _react.default.createElement(_FilterNumberInput.default, {
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: normalizedValue
          });

        case _Filters.FILTER_TYPES.TIME_SINCE_LAST_VISIT:
          normalizedValue = value ? (0, _immutable.Map)(value) : (0, _immutable.Map)({});
          return _react.default.createElement(_FilterNumberInput.default, {
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(e) {
              var days = e.target.value;
              var eProxy = {
                target: {
                  value: {
                    timeAmount: days,
                    timeUnit: 'DAYS'
                  }
                }
              };
              return _this.handleValueChange(eProxy);
            },
            value: normalizedValue.get('timeAmount')
          });

        case _Filters.FILTER_TYPES.TEXT:
          return _react.default.createElement(_FilterTextInput.default, {
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            operator: operator,
            size: size,
            value: value,
            type: operator === _Operators.EQ || operator === _Operators.STR_STARTS_WITH ? 'url' : 'text'
          });

        case _Filters.FILTER_TYPES.TOPIC:
          normalizedValue = value && (0, _immutable.List)(value);
          return _react.default.createElement(_FilterTopicSelect.default, {
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: normalizedValue,
            size: "long"
          });

        case _Filters.FILTER_TYPES.TOPIC_HISTORY:
          normalizedValue = value && (0, _immutable.List)(value);
          return _react.default.createElement(_FilterTopicSelect.default, {
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            size: size,
            value: normalizedValue
          });

        case _Filters.FILTER_TYPES.CTA_CLICKS:
          return _react.default.createElement(_FilterMultiSelect.default, {
            key: type // necessary to mount as two separated components
            ,
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(e) {
              var normalizedEvent = e.toJS ? e.toJS() : e;

              _this.handleValueChange(normalizedEvent);
            },
            options: [],
            placeholder: _I18n.default.text(this.getLangKey('select')),
            type: type,
            value: value
          });

        case _Filters.FILTER_TYPES.FORM_VIEW:
          return _react.default.createElement(_FilterMultiSelect.default, {
            labelConfig: labelConfig,
            key: type // necessary to mount as two separated components
            ,
            onBlur: this.props.onBlur,
            onChange: function onChange(e) {
              var normalizedEvent = e.toJS ? e.toJS() : e;

              _this.handleValueChange(normalizedEvent);
            },
            options: [],
            placeholder: _I18n.default.text(this.getLangKey('select')),
            type: type,
            value: value
          });

        case _Filters.FILTER_TYPES.QUERY_PARAM:
          return _react.default.createElement(_FilterKeyValueInput.default, {
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: value
          });

        case _Filters.FILTER_TYPES.LIST_MEMBERSHIP:
          return _react.default.createElement(_FilterListsSelect.default, {
            labelConfig: labelConfig,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              var change = val.toJS ? val.toJS() : val;

              _this.handleValueChange(change);
            },
            value: value,
            placeholder: _I18n.default.text(this.getLangKey('select'))
          });

        case _Filters.FILTER_TYPES.CONTACT:
          return _react.default.createElement(_FilterGenericSelect.default, {
            labelConfig: labelConfig,
            multi: false,
            options: _Contacts.default,
            onBlur: this.props.onBlur,
            onChange: function onChange(val) {
              return _this.handleValueChange(val);
            },
            value: value,
            type: "contact",
            size: "long"
          });

        default:
          return null;
      }
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        labelConfig: _react.PropTypes.object,
        type: _react.PropTypes.string.isRequired,
        operator: _react.PropTypes.string.isRequired,
        value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.object, _react.PropTypes.array, _react.PropTypes.bool]),
        size: _react.PropTypes.string
      };
    }
  }]);
  return FilterInput;
}(_react.Component);

exports.default = FilterInput;
module.exports = exports.default;